/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, Input, OnInit, output, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import {TaskListService} from "./task-list.service";
import {TaskViewVoModel} from "@well/delivery-libs/task-management/domain";
import { SharedComponentsModule } from '@well/shared-components';
import { AsyncPipe } from '@angular/common';
import { TaskCardSummaryComponent } from '../task-card-summary/task-card-summary.component';

@Component({
    selector: 'well-tasks-list',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss'],
    providers: [TaskListService],
    imports: [SharedComponentsModule, AsyncPipe, TaskCardSummaryComponent]
})
export class TasksListComponent implements OnInit {
  private taskListService = inject(TaskListService);

  @Input() segmentSelectedRsUuid: string | undefined = undefined;
  solutionDeleted = output<void>();

  $tasks: Observable<JsonApiResource<TaskViewVoModel[], JsonApiListResourceMetadataBase>> | undefined = undefined;

  ngOnInit() {
    if(this.segmentSelectedRsUuid) {
      this.$tasks = this.taskListService.loadTaskListFromSegment(this.segmentSelectedRsUuid);
    }
  }
}
